module.exports = __webpack_public_path__ + "img/questionamt.25931511.png";